import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { BriefService } from "../services/brief.service";
import { IBriefCreateRequest } from "@shared/lib/types/brief";
import { BRIEF_LIST_QUERY_KEY } from "@entities/brief/lib/constants";

export function useCreateBrief() {
  const {
    mutate: create,
    isLoading: isCreating,
    isSuccess: isCreated,
    data: newBriefData,
  } = useMutation({
    mutationFn: async (brief: IBriefCreateRequest) => {
      return await BriefService.createBrief(brief).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      });
    },
    options: {
      queryKey: [BRIEF_LIST_QUERY_KEY],
      skipInvalidation: false,
    },
    onSuccess: (c, _) => {
      ToastService.success("Brief Created Successfully");
      c.invalidateQueries({ queryKey: BRIEF_LIST_QUERY_KEY });
    },
  });

  return {
    create,
    isCreating,
    isCreated,
    newBriefData,
  };
}
